import { GetterTree } from "vuex";
import PartyState from "./PartyState";
import RootState from "../../RootState";

const getters: GetterTree<PartyState, RootState> = {};
export default getters;